export interface ILambdaConfigRegistry {
    loadLambdaConfigs(rootDir: string, paths: string[], env: string): Promise<string[]>;
    getLambdaConfigOverride(schemaRefName: string): any;
}

export enum Environment {
    dev = 'dev',
    int = 'int',
    test = 'test',
    dogfood = 'dogfood',
    prod = 'prod',
    gcc = 'gcc',
    dod = 'dod',
    gccHigh = 'gcchigh'
}

/* eslint-disable-next-line @typescript-eslint/naming-convention */
export const EnvironmentNameTranslation = {
    gcc: 'fairfax'
};

export interface ILambdaConfigBuilder<T> {
    configName(): string;
    buildConfig(env: Environment): T;
}
